import {postcodeError} from './pt-au-postcode-int17.js';
import {contextKey, destinationValid, readDestination, saveDestination, estimateProduct} from './pt-product-freight-model-sample17.js';
const contextNode=document.querySelector('[data-pt-freight-context]');
let context=null;
try {context=JSON.parse(contextNode?.textContent||'null');} catch {}
let storage;
try {storage=window.sessionStorage; readDestination(storage,context);} catch {}
const clearPreference=()=>{try{storage?.removeItem('pt-freight-destination-v1');}catch{}};
// This runs on every normal theme page, so logout/approval loss/company switches clear old context.
document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');
  if(link && /\/account\/logout(?:[/?#]|$)/.test(link.getAttribute('href'))) clearPreference();
},true);
window.addEventListener('pageshow',event=>{if(event.persisted && contextKey(context)){clearPreference();window.location.reload();}});
function initialise() {
 document.querySelectorAll('[data-pt-product-freight]').forEach(root=>{
  if(root.dataset.ptFreightInitialised) return;
  root.dataset.ptFreightInitialised='true';
  const country=root.querySelector('[data-freight-country]'),state=root.querySelector('[data-freight-state]'),region=root.querySelector('[data-freight-region]'),postcode=root.querySelector('[data-freight-postcode]');
  const master=root.querySelector('select[name="id"]'),form=root.closest('form'),error=root.querySelector('[data-freight-error]');
  if(!country || !state || !region || !postcode || !master || !form || !contextKey(context)) return;
  let source=null;try{source=JSON.parse(root.querySelector('[data-pt-freight-source]').textContent);}catch{}
  const serverEpoch=Number(root.dataset.serverTime)*1000, started=performance.now();
  const now=()=>Math.max(Date.now(),serverEpoch+performance.now()-started);
  const destination=()=>({country:country.value,province:(country.value==='Australia'?state.value:region.value).trim(),postcode:postcode.value.trim()});
  function countryControls(){
    const au=country.value==='Australia',nz=country.value==='New Zealand',uk=country.value==='United Kingdom';
    let provinces=[];try{provinces=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');}catch{}
    region.replaceChildren();
    region.add(new Option(provinces.length?'Select':'Not required',''));
    for(const [value,label] of provinces)region.add(new Option(label,value));
    state.hidden=!au;state.disabled=!au;state.required=au;
    region.hidden=au;region.disabled=au||!provinces.length;region.required=!au&&!!provinces.length;
    postcode.hidden=false;postcode.disabled=false;postcode.required=au||nz||uk;
    postcode.maxLength=au||nz?4:20;
    if(au||nz)postcode.pattern='[0-9]{4}';else postcode.removeAttribute('pattern');
    postcode.inputMode=au||nz?'numeric':'text';
    postcode.autocomplete='postal-code';
  }
  for(const option of country.options)if(option.value==='---')option.disabled=true;
  const favourites=['Australia','New Zealand','United Kingdom'];
  const preferred=favourites.map(value=>Array.from(country.options).find(option=>option.value===value)?.cloneNode(true)).filter(Boolean);
  for(const option of Array.from(country.options))if(favourites.includes(option.value)||option.value==='---')option.remove();
  const separator=new Option('---','');separator.disabled=true;
  country.prepend(...preferred,separator);
  country.value='Australia';countryControls();
  const saved=storage && readDestination(storage,context,now());
  if(saved && Array.from(country.options).some(o=>o.value===saved.country)){
    country.value=saved.country;countryControls();state.value=saved.province;region.value=saved.province;postcode.value=saved.postcode;
  }
  let timer=0,generation=0,variantId=master.value;
  const panels=()=>Array.from(root.querySelectorAll('[data-pt-native-prices] [data-pt-variant]'));
  const wipe=()=>{root.querySelectorAll('[data-freight-cell]').forEach(cell=>{cell.textContent='—';cell.removeAttribute('data-estimate-key');});};
  function render(){
    const d=destination(),complete=destinationValid(d) && country.value!=='---' && (!region.required || !!region.value);
    if(root.dataset.estimatesEnabled==='false'){wipe();return;}
    for(const panel of panels()){
      for(const cell of panel.querySelectorAll('[data-freight-cell]')){
        cell.textContent='—';
        if(!complete || panel.dataset.ptVariant!==String(variantId))continue;
        const result=source?estimateProduct(source,{context,currency:root.dataset.currency,now:now(),expectedRevision:root.dataset.sourceRevision,
          productId:root.dataset.productId,variantId,liveWeightGrams:Number(panel.dataset.freightWeight),liveRequiresShipping:panel.dataset.freightShippable==='true',
          destination:d,quantity:Number(cell.dataset.freightQuantity),kind:cell.dataset.freightKind,unitPriceCents:Number(cell.dataset.freightPrice)}):{status:'unavailable'};
        if(result.status!=='estimate'){cell.textContent='Please contact us for freight estimate.';continue;}
        const amount=document.createElement('span');amount.textContent=new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',minimumFractionDigits:0,maximumFractionDigits:2}).format(result.cents/100);
        const suffix=document.createElement('small');suffix.className='pt-freight-quantity';suffix.textContent=result.sample?'for 1–5 samples':`for ${result.quantity.toLocaleString('en-AU')} ${result.quantity===1?'unit':'units'}`;
        cell.replaceChildren(amount,document.createTextNode(' '),suffix);
        cell.dataset.estimateKey=JSON.stringify([result.revision,contextKey(context),variantId,result.quantity,d.country,d.province,d.postcode]);
      }
    }
  }
  function update({persist=false,immediate=false}={}){
    const d=destination(),message=postcodeError(d.country,d.province,d.postcode);
    postcode.setCustomValidity(message);
    postcode.setAttribute('aria-invalid',String(!!message && !!d.postcode));
    if(error){error.textContent=d.postcode?message:'';error.hidden=false;}
    clearTimeout(timer);const turn=++generation;wipe();
    if(persist && storage)saveDestination(storage,context,destination(),now());
    const key=JSON.stringify([variantId,destination()]);
    if(immediate){render();return;}
    timer=setTimeout(()=>{if(turn===generation && key===JSON.stringify([variantId,destination()]))render();},250);
  }
  country.addEventListener('change',()=>{state.value='';region.value='';postcode.value='';countryControls();update({persist:true});});
  for(const control of [state,region,postcode])for(const event of ['input','change'])control.addEventListener(event,()=>update({persist:true}));
  master.addEventListener('change',()=>{variantId=master.value;update({immediate:true});});
  document.addEventListener('pt:variant-change',event=>{
    // Existing event is document-wide. Ignore a different form's variant; null clears this single-product view.
    const id=event.detail?.variantId;
    if(id!==null && !panels().some(p=>p.dataset.ptVariant===String(id)))return;
    variantId=id;update({immediate:true});
  });
  if(!form.matches('form[data-pt-e09-form="true"]'))form.addEventListener('submit',event=>{
    if(!destinationValid(destination())){
      event.preventDefault();event.stopImmediatePropagation();update({immediate:true});
      for(const c of [country,state,region,postcode])if(!c.disabled && !c.checkValidity()){c.reportValidity();break;}
    }
  },true);
  // Invalidate rendered amounts while an open page crosses the source lease boundary.
  if(source?.schemaVersion===1 && !Object.hasOwn(source,'freshnessPolicy')){const remaining=Date.parse(source.expiresAt)-now();if(remaining>0 && remaining<2147483647)setTimeout(()=>update({immediate:true}),remaining+1);}
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)update({immediate:true});});
  update({immediate:true});
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise);else initialise();
document.addEventListener('shopify:section:load',initialise);
